"use strict";

App.Pages.StatEmotionMap = class StatEmotionMap extends PF.Page
	{

	static get options()
		{
		return {
			rights: {
				user: true
			},
			path: '/stat-emotion-map',
			nameRu: 'Статистика Эмоций - карта',
		};
		}

	static get template()
		{
		//language=HTML
		return `
			<div class="page navbar-fixed">

				<div class="page-content ptr-content" pf="pageContent">


					<div class="page-header">
						<a href="#" onclick="history.back();" class="breadcrumb link"><i class="icon material-icons">chevron_left</i>Вернуться назад</a>
						<h3>Статистика Эмоций - карта</h3>
					</div>

					<div class="stretch-block">
						<form class="filterForm" pf="form">
							<div class="row resizable">
								<div class="col-65">
									<div pf="preset"></div>
								</div>
								<div class="col-35">
									<input pf="dates"/>
								</div>
							</div>
						</form>


						<div class="content" pf="mapContent" style="height: 75vh; position: relative">
							<button style="position:absolute;z-index:10; top: 120px; left:10px; height: 40px; width: 40px" class="button button-fill" pf="zoomIn">
								<i class="material-icons" style="line-height:40px">zoom_in</i>
							</button>
							<button style="position:absolute;z-index:10; top: 180px; left:10px; height: 40px; width: 40px" class="button button-fill" pf="zoomOut">
								<i class="material-icons" style="line-height:40px">zoom_out</i>
							</button>


							<div pf="map" style="width: 100%; height:100%; overflow: hidden">

							</div>
						</div>
					</div>

				</div>

			</div>

		`;
		}

	init()
		{
		super.init();

		this.statFilters = new PF.Model({represent: "user-data/stat-stellas", saveOnModify: true, raw: {data: {}}});

		this.statFilters.onValue('options.loadStatus', 'loaded', () => {
			this.form = new PF.Form({
				dom: {element: this.dom.form},
				model: this.statFilters,
				keyPrefix: 'data.',
				toastOnSave: false,
				fieldsConfig: {
					dateDiapason: {
						class: PF.Field.DateDiapasonWithPreset,
						presetConfig: {
							dom: {
								element: this.dom.preset
							},
							key: 'data.diapasonPreset',
						},
						datesConfig: {
							dom: {
								element: this.dom.dates
							},
							startKey: 'data.calendar.start',
							finishKey: 'data.calendar.finish',
						},
					},
				}
			});

			this.statFilters.on('save-success', () => {
				this.loadPlots();
			}, true);

		});


		ymaps.ready(() => {
			this.map = new ymaps.Map(this.dom.map.node, {
				center: app.mapConfig.defaultCenter,
				zoom: 10, //app.mapConfig.defaultZoom,
				// ...app.mapConfig
				controls: ['fullscreenControl', 'typeSelector', 'geolocationControl', 'rulerControl'],
				// controls: []
			}, {
				maxZoom: 23
			});

			this.dom.zoomIn.on('click', () => {
				this.map.setZoom(this.map.getZoom() + 1);
			});
			this.dom.zoomOut.on('click', () => {
				this.map.setZoom(this.map.getZoom() - 1);
			});
		}); //end ymaps

		this.chekPoint = 0;

		}

	loadPlots()
		{
		try
			{
			if (
				(this.statFilters.get('data.diapasonPreset', null, null) !== null || this.statFilters.get('data.calendar', null, null) !== null) &&
				this.statFilters.get('data.discrete', null, null) !== null)
				{

				this.chekPoint++;
				let start = this.statFilters.data.calendar.start;
				let finish = this.statFilters.data.calendar.finish;
				if (start !== null && finish === null)
					{
					this.chekPoint++;
					}
				if (start !== null && finish !== null)
					{
					this.chekPoint = 1;
					}
				if (this.chekPoint === 1)
					{
					app.toast("Запрос данных...");

					app.request('/demo/plot/stat-emotion-map', [], (response) => {
						app.toast("Ответ получен.");
						this.response = Util.isJsonString(response) ? JSON.parse(response) : response;
						console.log(this.response);
						this.chekPoint = 0;
						if (this.response.status != 'FAIL')
							{
							app.toast("Обработка данных.");
							this.map.geoObjects.removeAll();
							let districtEmotions = new PF.Models({
								raw: this.response.data.maxEmotionByDistrict
							});

							this.districtList = new PF.Map.PolygonList({
								map: this.map,
								models: districtEmotions,
								itemClass: District,
							});
							}
						else
							{
							app.toast("Нет данных.");
							}
					});
					}
				}
			}
		catch (e)
			{
			console.log("loadPlots error");
			}
		}

	};


class District extends PF.Map.PolygonList.Item
	{
	onRender()
		{
		this.model.border = JSON.parse(this.model.border);
		if (this.model.get('border', null, null) !== null)
			{
			for (let index = 0; index < this.model.border.length; index++)
				{
				this.districtPoint = new ymaps.Polygon(
					this.model.border[index],
					{
						hintContent: this.model.d_name + "(" + this.model.name + ")",
					},
					{
						// Опции.
						// Цвет заливки 
						fillColor: this.model.get('color', 'rgba(0,0,0,0)', 'rgba(0,0,0,0)'),
						// Цвет границ (синий)
						strokeColor: '#0000FF',
						// Прозрачность (полупрозрачная заливка)
						opacity: 0.6,
						// Ширина линии
						strokeWidth: 1,
						// Стиль линии
						// strokeStyle: 'shortdash',
						// Делаем полигон прозрачным для событий карты.
						interactivityModel: 'default#transparent',
					}
				);
				this.list.map.geoObjects.add(this.districtPoint);
				}
			}

		} // onRender

	}